/* eslint-disable*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DtpContentContainer, DtpNoContent, DtpButton } from 'dtp-react-components';
import {
  Table,
  Button,
} from '../../components/index';
import {
  doGet,
  doPut,
  doGetDocumentoComUrlDinamica,
  trataMensagensErro,
  trataMensagemSucesso,
  buscaDestinatarios,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import User from '../../domain/User';
import InfoCronogramaVisualCompetencia from '../cadastros/cronograma-pagamentos/InfoCronogramaVisualCompetencia';

class ConsultaCronogramaPagamento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      acao: null,
      listaRegistrosFiltrada: null,
      listaRegistrosIndexada: [],
      registroVindoDoRequest: null,
      showNoContent: false,
      listaRegistrosIndexadaAtualizada: false,
      estadoTabela: {
        quantidadeTotalResultados: 0,
        resultadosPorPagina: 10,
        paginaAtual: 1,
      },
      filtrosPesquisa: {},
      showDocumentUploadModal: false,
      showContestacaoModal: false,
      showDadosBancariosModal: false,
      cronogramaPagamento: {
        ano: null,
        mes: null,
        dataCND: null,
	      dataObitos: null,
        dataFechamentoPrevia: null,
        dataConsultaPrevia: null,
        dataFechamentoFolha: null,
        dataRelatoriosBG: null,
	      dataRelatoriosBB: null,
        dataEnvioBB: null,
        dataPrazoPagamento: null,
        dataPrazoDefesa: null,
        dataPrazoAnalise: null,
      },
    };
  }
  componentDidMount() {
     this.executaConsulta();
   }
   preparaNovaConsulta = () => {
    const estadoTabela = {
      quantidadeTotalResultados: 0,
      resultadosPorPagina: 10,
      paginaAtual: 1,
    };
    this.setState({
      listaRequerimentosFiltrada: null,
      estadoTabela,
    }, this.realizaConsulta());
  }

  lotacao = this.props.auth.userData.lotacoes[0];

  executaConsulta = () => {
   // if (Object.entries(this.state.filtrosConsulta).length !== 0) {
      const { resultadosPorPagina } = { ...this.state.estadoTabela };
      const primeiroItem = (this.state.estadoTabela.paginaAtual - 1) * resultadosPorPagina;
      doGet(
        'cronogramas-pagamento/lista-cronogramas',
        this.tratarSucesso,
        this.tratarErro,
        {
          'start-position': primeiroItem,
          'max-results': resultadosPorPagina,
        },
      );
  }

  trataSucessoResponseEnvio = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    }, this.trataSucesso);
  }

   trataErrosResponse = (error) => {
    if (error && error.data) {
      trataMensagensErro(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);
    }
  }

  tratarSucesso = (response) => {
    let quantidadeTotalResultados = 0;
    if (response.headers['content-range']) {
      const { headers } = { ...response };
      // eslint-disable-next-line
      quantidadeTotalResultados = headers['content-range'].split('/')[1];
    }
    const { estadoTabela } = { ...this.state };
    estadoTabela.quantidadeTotalResultados = quantidadeTotalResultados;
    if (response.data === '') {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: [],
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    } else {
      this.setState({
        showNoContent: false,
        listaRegistrosIndexada: response.data,
        listaRegistrosIndexadaAtualizada: true,
        estadoTabela,
      });
    }
  };

  /**
   * Trata filtros na lista que veio do servidor (Componente FiltroPagamentos)
   */
  tratarErro = (error) => {
    if (error) {
      const { data } = { ...error };
      if (error.status) {
        this.setState({
          noContentPrimaryMessage: `${data.mensagem}`,
          noContentSecondaryMessage: `${data.descricao}`,
        });
      } else {
        this.setState({
          noContentPrimaryMessage: 'Ocorreu uma falha de comunicação com o serviço de compensação previdenciária.',
          noContentSecondaryMessage: 'Tente novamente mais tarde.',
        });
      }
    }
  }

  handleChange = (e, name) => {
    this.setState({
      ...this.state,
      [name]: e,
    });
  }

  formatarValorLabel = (valor) => {
    let valorFormatado = '';
    if (valor) {
      valorFormatado = valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 3 });
    }
    return valorFormatado;
  };

  detalharCronograma = (row) => {
    this.props.history.push(`/cadastros/cronograma-pagamento/detalhe/${row.mes}/${row.ano}/detalhar`);
  }

  alterarCronograma = (row) => {
    this.props.history.push(`/cadastros/cronograma-pagamento/detalhe/${row.mes}/${row.ano}/alterar`);
  }

  visualizarCronograma = (row) => {
    let indice = row.indiceCronograma ;    
    let cronogramaEscolhido = this.state.listaRegistrosIndexada[indice];
    let cronogramaPosterior = this.state.listaRegistrosIndexada[indice -1];
    let cronogramaAnterior = this.state.listaRegistrosIndexada[indice +1];
    let url =  '/cadastros/cronograma-pagamento/visualizar-cronogramas'
    this.props.history.push(`${url}/${cronogramaEscolhido.mes}/${cronogramaEscolhido.ano}/${cronogramaPosterior.mes}/${cronogramaPosterior.ano}/${cronogramaAnterior.mes}/${cronogramaAnterior.ano}`);
    }

  montaAcoes = (row) => {
    let acaoDetalhar = true;
    let acaoVisualizar = true;
    const acaoAlterar = row.habilitarBotao;
    const botaoAlterar = acaoAlterar ? (
      <Button
        hint="Alterar"
        icon="ico-doc-pencil"
        mini
        onClick={() => this.alterarCronograma(row)}
      />
    ) : '';
    const botaoDetalhar = acaoDetalhar ? (
      <Button
        hint="Detalhar"
        icon="ico-doc-magnifier"
        mini
        onClick={() => this.detalharCronograma(row)}
      />
    ) : '';

    const botaoVisualizarCalendario = acaoVisualizar ? (
      <Button
        hint="Visualizar"
        icon="ico-calendar"
        mini
        onClick={() => this.visualizarCronograma(row)}
    />
    ) : '';

    return (
      <React.Fragment>
      <div> 
        {botaoAlterar}
        {botaoDetalhar}
        {row.habilitarBotaoVisualizar === 1 ? botaoVisualizarCalendario : ''}
      </div>
      </React.Fragment>
    );
  }
  createActionColumn = (cell, row) => (
    this.montaAcoes(row)
  )

  montaColunas = () => { 
    const consultaPagamentoTableHeader = this.colunasDefault.slice();
    let colunasEspecificas = [];
    if (colunasEspecificas) {
      colunasEspecificas = colunasEspecificas.concat(consultaPagamentoTableHeader);
    }
    colunasEspecificas.push({
      id: 'acoes',
      label: 'Ações',
      dataFormat: this.createActionColumn,
    });

    return colunasEspecificas;
  }

  colunasDefault = [
    {
      id: 'competencia',
      label: 'Competência',
    },{
      id: 'dataConsultaPrevia',
      label: 'Inicio Consulta Prévia',
    },{
      id: 'dataEnvioBB',
      label: 'Envio arquivo ao BB',
    },{
      id: 'dataPrazoPagamento',
      label: 'Prazo de Pagamento',
    },{
      id: 'dataPrazoDefesa',
      label: 'Marco Limite Defesa',
    },{
      id: 'dataPrazoAnalise',
      label: 'Marco Limite Análise',
    }];

  defineListaParaTabela = () => {
    if (this.state.listaRegistrosFiltrada !== null) {
      return this.state.listaRegistrosFiltrada;
    }
    return this.state.listaRegistrosIndexada;
  }

  
  alterarPagina = (pagina, page) => {
    const { estadoTabela } = { ...this.state };
    if (pagina === 0) {
      estadoTabela.paginaAtual = 1;
    } else {
      estadoTabela.paginaAtual = pagina;
    }

    if (page) {
      estadoTabela.resultadosPorPagina = page;
    }

    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  alterarResultadosPorPagina = (resultadosPorPagina) => {
    const { estadoTabela } = { ...this.state };
    estadoTabela.resultadosPorPagina = resultadosPorPagina;
    this.setState({
      estadoTabela,
      ...this.state,
    }, this.realizaConsulta());
  }

  trataSucesso = () => {
    this.realizaConsulta(this.state.filtrosConsulta);
    trataMensagemSucesso(['Contestação de pagamento criada.']);
    this.handleModalContestacao('showContestacaoModal');
  }

  trataSucessoResponseEnvio = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
    }, this.trataSucesso);
  }

  trataErrosResponse = (error) => {
    if (error && error.data) {
      trataMensagensErro(['Houve um erro na tentativa de se comunicar com o serviço. Por favor, tente novamente mais tarde.']);
    }
  }

  newCadastroCronograma = () => {

    if(( this.state.listaRegistrosIndexada &&  this.state.listaRegistrosIndexada.length > 0)
     && this.state.listaRegistrosIndexada[0].ano !== null ){
      let mes = this.state.listaRegistrosIndexada[0].mes + 1;
      let ano = this.state.listaRegistrosIndexada[0].ano;
        if ( mes == 13){  mes = 1;
          ano = ano + 1};  
          this.props.history.push(`/cadastros/cronograma-pagamento/${mes}/${ano}/novo`);  
    } else  {
      let mes = '0';
      let ano = '0';
          this.props.history.push(`/cadastros/cronograma-pagamento/${mes}/${ano}/novo`); 
    }
}
 
  render() {
    const options = {
      noDataText: 'Nenhum Cronograma a ser exibido',
      hideSizePerPage: false,
      onPageChange: this.alterarPagina,
      page: this.state.estadoTabela.paginaAtual,
      sizePerPage: this.state.estadoTabela.resultadosPorPagina,
      sizePerPageList: listUtils.linhasPorPagina,
    };
    const fetchInfo = {
      dataTotalSize: this.state.estadoTabela.quantidadeTotalResultados,
    };
    const consultaPagamentoTableHeader = this.montaColunas();

    return (
      this.state.showNoContent ? (
        <DtpNoContent
          primarylabel={this.state.noContentPrimaryMessage}
          secondarylabel={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />
      ) : (
        <DtpContentContainer>
          <Table
            legend="Cronograma de Pagamento"
            bordered
            fetchInfo={fetchInfo}
            data={this.defineListaParaTabela()}
            options={options}
            listaTableHeader={consultaPagamentoTableHeader}
            pagination
            remote
          />
          <DtpButton
            //disabled={this.verificaSeCampoDesabilitado()}
            className="dtp-primary right"
            title="Adicionar Cronograma"
            accessibilityName="Adicionar Cronograma"
            onClick={() => this.newCadastroCronograma()}
          />
        </DtpContentContainer>
      )
    );
  }
}

ConsultaCronogramaPagamento.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      acao: PropTypes.string,
      mes: PropTypes.string,
      ano: PropTypes.string,
      participanteUm: PropTypes.string,
      participanteDois: PropTypes.string,
    }).isRequired,
  }),
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }).isRequired,
};

ConsultaCronogramaPagamento.defaultProps = {
  match: null,
};

export default ConsultaCronogramaPagamento;



// WEBPACK FOOTER //
// ./src/pages/consultas/ConsultaCronogramaPagamentos.jsx